import {GridItemType, GridType} from "../../types";
import {DIMENSION_GRID, OFFSET_ITEM} from "../../contants";
import {getInitialDragData} from "./getInitialDragData";

export const initialGridData = (sizeItem: number): GridItemType[][] => {
    const newGrid: GridType = [];
    let index = 0;

    for (let i = 0; i < DIMENSION_GRID; i++) {
        newGrid[i] = [];

        for (let c = 0; c < DIMENSION_GRID; c++) {
            const x = i + (sizeItem + OFFSET_ITEM) * i;
            const y = c + (sizeItem + OFFSET_ITEM) * c;

            const item = undefined;

            newGrid[i][c] = {
                index,
                row: i,
                col: c,
                isHinted: false,
                size: sizeItem,
                x,
                y,
                item,
            };

            index++;
        }
    }

    return newGrid;
};
